import { Component } from 'react'
import { Segment, Form } from 'semantic-ui-react'

class ReportCaseSummarySection extends Component {
    render() {
        const { values, onChange } = this.props

        return (
            <Segment>
                <Form>
                    <Form.Group widths='equal'>
                        <Form.Input
                            label='Company Name'
                            value={values.companyName}
                            onChange={(e) => onChange('companyName', e.target.value)}
                        />

                        <Form.Select
                            label='Status'
                            value={values.status}
                            disabled
                            options={[
                                { text: 'Pending Assign', value: 'pending_assign' },
                                { text: 'Pending Doc Sent', value: 'pending_doc_sent' },
                                { text: 'Pending Doc Rec', value: 'pending_doc_rec' },
                                { text: 'Pending Payment', value: 'pending_payment' },
                                { text: 'Pending Release', value: 'pending_release' },
                                { text: 'Closed', value: 'closed' }
                            ]}
                            onChange={(e, { value }) => onChange('status', value)}
                        />
                    </Form.Group>

                    {/* NEW: CS + Tax Agent */}
                    <Form.Group widths='equal'>
                        <Form.Input
                            label='Company Secretary'
                            value={values.companySecretary || ''}
                            onChange={(e) => onChange('companySecretary', e.target.value)}
                        />

                        <Form.Input
                            label='Tax Agent'
                            value={values.taxAgent || ''}
                            onChange={(e) => onChange('taxAgent', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Due Date'
                            value={toDateInput(values.dueDate)}
                            onChange={(e) => onChange('dueDate', e.target.value)}
                        />

                        <Form.Input
                            type='date'
                            label='Next Follow-up'
                            value={toDateInput(values.nextFollowUpDate)}
                            onChange={(e) => onChange('nextFollowUpDate', e.target.value)}
                        />
                    </Form.Group>
                    
                    <Segment
                        style={{ marginTop: 20 }}
                    >
                        <Form.Checkbox
                            toggle
                            label='Is Urgent'
                            checked={!!values.isUrgent}
                            onChange={(e, { checked }) =>
                                onChange('isUrgent', checked)
                            }
                        />
                    </Segment>
                </Form>
            </Segment>
        )
    }
}

function toDateInput(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export default ReportCaseSummarySection